import { render, staticRenderFns } from "./blankPage.vue?vue&type=template&id=633d3a35&scoped=true"
import script from "./blankPage.vue?vue&type=script&lang=js"
export * from "./blankPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d3a35",
  null
  
)

export default component.exports